"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamUsersList = void 0;
var react_1 = __importDefault(require("react"));
var react_admin_1 = require("react-admin");
var dist_1 = __importDefault(require("jsonexport/dist"));
var Teams_module_css_1 = __importDefault(require("../Teams/Teams.module.css"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var RAStyles_2 = require("../common/ReactAdmin/RAStyles");
var styles_1 = require("@mui/material/styles");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_2 = require("react");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var UpdateRolesModal_1 = __importDefault(require("./UpdateRolesModal"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var exporter = function (users) {
    var usersForExport = users.map(function (user) {
        var name = user.name, email = user.email, qteams = user.qteams, updated_at = user.updated_at;
        var qteam = qteams.map(function (team) { return team.name; }).join(", ");
        var userForExport = {
            name: name,
            email: email,
            qteam: qteam,
            updated_at: updated_at
        };
        return userForExport;
    });
    (0, dist_1.default)(usersForExport, {
        headers: ["name", "email", "qteam", "updated_at"]
    }, function (err, csv) {
        if (err) {
            console.error("Error exporting CSV:", err);
            return;
        }
        (0, react_admin_1.downloadCSV)(csv, "users");
    });
};
var ListActions = function () { return (react_1.default.createElement(react_admin_1.TopToolbar, { className: "my-auto" },
    react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_2.ExportButtonTheme },
        react_1.default.createElement(react_admin_1.ExportButton, { sx: {
                position: "relative",
                bottom: "65px",
                marginRight: "160px",
                color: "var(--info-color)",
                backgroundColor: "var(--secondary-color)",
                fontFamily: "Geomanist-bold",
                borderRadius: "4px",
                textTransform: "capitalize",
                padding: "15px",
                fontSize: "14px",
                height: "37px",
                boxShadow: " 6px 0px 18px #2d2d2d0c ",
                "&:hover": {
                    backgroundColor: "var(--secondary-color)",
                    color: "var(--info-color)",
                },
                "&:active": {
                    backgroundColor: "var(--info-color)",
                    color: "var(--secondary-color)",
                    "& .MuiSvgIcon-root": {
                        color: "var(--secondary-color)",
                    }
                }
            } })))); };
var CheckBoxAction = function (_a) {
    var onCheckBoxTick = _a.onCheckBoxTick;
    var selectedIds = (0, react_admin_1.useListContext)().selectedIds;
    react_1.default.useEffect(function () {
        onCheckBoxTick(selectedIds);
    }, [selectedIds]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
var avatarStyles = [
    { backgroundColor: "var(--secondary-color)", color: "var(--info-color)" },
    { backgroundColor: "var(--primary-color)", color: "var(--secondary-color)" },
    { backgroundColor: "var(--info-color)", color: "var(--secondary-color)" },
];
var UserAvatar = function (_a) {
    var imageUrl = _a.imageUrl, name = _a.name;
    var fixedStyle = { backgroundColor: "var(--info-color)", color: "var(--secondary-color)" };
    var renderAvatarContent = function () {
        if (imageUrl) {
            return react_1.default.createElement("img", { src: imageUrl, alt: "User Avatar", className: Teams_module_css_1.default.user_avatar_image });
        }
        else {
            var initial = name.charAt(0).toUpperCase();
            return (react_1.default.createElement("div", { className: "".concat(Teams_module_css_1.default.user_avatar_initial, " ns-font-family-bold"), style: fixedStyle },
                react_1.default.createElement("span", { className: Teams_module_css_1.default.user_avatar_initial_span }, initial)));
        }
    };
    return (react_1.default.createElement("div", { className: Teams_module_css_1.default.user_avatar_container }, renderAvatarContent()));
};
var TeamAvatar = function (_a) {
    var name = _a.name, _b = _a.styleIndex, styleIndex = _b === void 0 ? 0 : _b;
    var style = avatarStyles[styleIndex % avatarStyles.length];
    var renderAvatarContent = function () {
        var initial = name.charAt(0).toUpperCase();
        return (react_1.default.createElement("div", { className: "".concat(Teams_module_css_1.default.team_avatar_initial, " ns-font-family-bold"), style: style },
            react_1.default.createElement("span", { className: Teams_module_css_1.default.team_avatar_initial_span }, initial)));
    };
    return (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement("pre", { style: { margin: 0, padding: 0, fontFamily: "Geomanist" } }, name), placement: "top", arrow: true, PopperProps: {
            sx: {
                ".MuiTooltip-arrow": {
                    color: "var(--secondary-color)",
                },
                ".MuiTooltip-tooltip": {
                    backgroundColor: "var(--secondary-color)",
                    color: "var(--info-color)",
                    borderRadius: "7px",
                    padding: "12px"
                },
            },
        } },
        react_1.default.createElement("div", { className: Teams_module_css_1.default.team_avatar_container }, renderAvatarContent())));
};
var TeamAvatarGroup = function (_a) {
    var teams = _a.teams;
    var maxDisplay = 3;
    var additionalTeamsCount = teams.length > maxDisplay ? teams.length - maxDisplay : 0;
    var displayedTeams = teams.slice(0, maxDisplay);
    var additionalTeamNames = teams.slice(maxDisplay).map(function (team) { return team.name; }).join("\n");
    return (react_1.default.createElement("div", { className: Teams_module_css_1.default.team_avatar_group_container },
        additionalTeamsCount > 0 && (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement("pre", { style: { margin: 0, padding: 0, fontFamily: "Geomanist" } }, additionalTeamNames), placement: "top", arrow: true, PopperProps: {
                sx: {
                    ".MuiTooltip-arrow": {
                        color: "var(--secondary-color)",
                    },
                    ".MuiTooltip-tooltip": {
                        backgroundColor: "var(--secondary-color)",
                        color: "var(--info-color)",
                        borderRadius: "7px",
                        padding: "12px"
                    },
                },
            } },
            react_1.default.createElement("div", { className: Teams_module_css_1.default.additional_teams_tooltip_container },
                react_1.default.createElement("span", { className: " ns-font-family-bold", style: { position: "relative", top: "2px", fontSize: "15px" } },
                    "+",
                    additionalTeamsCount)))),
        displayedTeams.map(function (team, index) { return (react_1.default.createElement(TeamAvatar, { key: team.id, name: team.name, styleIndex: index })); })));
};
var RowActionMenu = function (_a) {
    var handleRowClick = _a.handleRowClick;
    var _b = (0, react_2.useState)(null), menuAnchorElement = _b[0], setMenuAnchorElement = _b[1];
    var menuOpen = Boolean(menuAnchorElement);
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var record = (0, react_admin_1.useRecordContext)();
    var props = (0, useTypedPage_1.default)().props;
    var currentUserID = props.user.id;
    var handleClick = function (e) {
        setMenuAnchorElement(e.currentTarget);
        e.stopPropagation();
    };
    var handleClose = function (e) {
        setMenuAnchorElement(null);
        e.stopPropagation();
    };
    var handleDeleteUser = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.stopPropagation();
                    handleClose(e);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    userId = Number(record.id);
                    return [4 /*yield*/, ApiManager_1.default.removeUserFromAccount(userId)];
                case 2:
                    _a.sent();
                    logger.info("Successfully removed user with ID ".concat(userId));
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Error removing user with ID ".concat(record.id), error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.IconButton, { "aria-label": "more", id: "long-button", "aria-controls": menuOpen ? "long-menu" : undefined, "aria-expanded": menuOpen ? "true" : undefined, "aria-haspopup": "true", onClick: function (e) {
                handleClick(e);
            }, className: Teams_module_css_1.default.icon_button },
            react_1.default.createElement("span", { className: Teams_module_css_1.default.custom_icon_container }, menuOpen ?
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes, className: Teams_module_css_1.default.close_menu_icon }) :
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleEllipsis, className: Teams_module_css_1.default.open_menu_icon }))),
        react_1.default.createElement(material_1.Menu, { id: "teams-dropdown-menu", MenuListProps: {
                "aria-labelledby": "dropdown-button",
            }, anchorEl: menuAnchorElement, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left",
            }, open: menuOpen, onClose: handleClose, sx: {
                marginLeft: "-75px",
                width: "130px",
                borderRadius: "7px",
            } },
            react_1.default.createElement(material_1.MenuItem, { onClick: function (e) {
                    handleRowClick(record.id, "users", record);
                    handleClose(e);
                }, className: "ns-font-family", style: { color: "var(--info-color)", fontSize: "12px" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "1x", style: {
                        marginRight: "5px"
                    } }),
                t("Edit")),
            react_1.default.createElement("span", null, record.id !== currentUserID && (react_1.default.createElement(material_1.MenuItem, { className: "ns-font-family", style: {
                    color: "var(--info-color)",
                    fontSize: "12px",
                    display: "block"
                }, onClick: handleDeleteUser },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "1x", style: {
                        marginRight: "5px"
                    } }),
                t("Delete")))))));
};
var LoginMethod = function (user) {
    var imageUrl = "/images/login-methods/qplay.svg";
    if (user.sso_provider === "azure") {
        imageUrl = "/images/login-methods/entra-id.svg";
    }
    else if (user.sso_provider === "google") {
        imageUrl = "/images/login-methods/google.svg";
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("img", { src: imageUrl, style: { width: "25px", height: "25px" } })));
};
var TeamUsersList = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var refresh = (0, react_admin_1.useRefresh)();
    var unSelect = (0, react_admin_1.useUnselect)("users");
    var usersFilters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "name", placeholder: t("Search users"), alwaysOn: true, key: "queryFilter" })];
    var _a = (0, react_2.useState)(false), checkBoxIsActive = _a[0], setCheckBoxIsActive = _a[1];
    var _b = (0, react_2.useState)([]), bulkActionUserIds = _b[0], setBulkActionUserIds = _b[1];
    var _c = (0, react_2.useState)({ id: 0, roles: [] }), user = _c[0], setUser = _c[1];
    var modalState = (0, q_play_components_1.useModal)();
    var pageProps = (0, useTypedPage_1.default)().props;
    var onCheckBoxTickHandler = function (selectedIds) {
        if (selectedIds.length > 0) {
            setCheckBoxIsActive(true);
            setBulkActionUserIds(selectedIds);
        }
        else {
            setCheckBoxIsActive(false);
            setBulkActionUserIds([]);
        }
    };
    var onDeleteHandler = function () {
        var refreshDebouncer = new q_play_core_1.Debouncer(refresh, 50);
        bulkActionUserIds.forEach(function (userId) {
            ApiManager_1.default.removeUserFromAccount(userId).then(function () { return refreshDebouncer.debounce(); });
        });
        unSelect(bulkActionUserIds);
        setBulkActionUserIds([]);
    };
    var openUpdateRolesModal = function (_id, _resource, record) {
        setUser(record);
        modalState.toggle();
        return false;
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaTeamsFilterInputTheme },
            react_1.default.createElement(react_admin_1.ListBase, __assign({}, props, { exporter: exporter }),
                react_1.default.createElement("div", { style: { display: "flex", gap: "10px", marginBottom: "15px" } },
                    react_1.default.createElement(q_play_components_1.Button, { dataCy: "teamListDeleteButton", text: t("Delete"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Teams_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive, onClick: onDeleteHandler }),
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_2.RaSearchInputTheme },
                        react_1.default.createElement(react_admin_1.ListToolbar, { filters: usersFilters, actions: react_1.default.createElement(ListActions, null) }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTeamsTheme },
                        react_1.default.createElement(react_admin_1.Datagrid, { "data-cy": "TeamListRows", hover: false, sx: RAStyles_1.RaTeamsDataGridSx, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { onCheckBoxTick: onCheckBoxTickHandler }), rowClick: openUpdateRolesModal },
                            react_1.default.createElement(react_admin_1.FunctionField, { label: t("Photo"), sortable: false, render: function (record) { return (react_1.default.createElement(UserAvatar, { imageUrl: record.profile_photo_path, name: record.name })); } }),
                            react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name") }),
                            react_1.default.createElement(react_admin_1.TextField, { source: "email", label: t("Email") }),
                            react_1.default.createElement(react_admin_1.FunctionField, { label: t("Login method"), sortable: false, render: LoginMethod }),
                            react_1.default.createElement(react_admin_1.TextField, { source: "phone_number", label: t("Phone Number") }),
                            react_1.default.createElement(react_admin_1.ArrayField, { source: "qteams", sortable: false, label: t("Teams") },
                                react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(TeamAvatarGroup, { teams: record.qteams || [] })); } })),
                            react_1.default.createElement(react_admin_1.DateField, { showTime: false, label: t("Last login"), source: "updated_at", textAlign: "center" }),
                            react_1.default.createElement(RowActionMenu, { handleRowClick: openUpdateRolesModal })))),
                react_1.default.createElement(Pagination_1.default, null))),
        react_1.default.createElement(UpdateRolesModal_1.default, { modal: modalState, user: user, refresh: refresh, currentUser: pageProps.user.id })));
};
exports.TeamUsersList = TeamUsersList;
exports.default = exports.TeamUsersList;
